import React, {
  useState,
  useMemo,
  useContext,
  createContext,
  useEffect,
} from "react";
import supabase from "../lib/supabase";

const AppContext = createContext();

const Context = ({ children }) => {
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  const [notify_popup, setNotify_popup] = useState({
    status: localStorage.getItem("notify_popup") ? "done" : "idle",
  });
  const [showInstallPopup, setShowInstallPopup] = useState({
    status: localStorage.getItem("install_prompt_shown") ? "done" : "idle",
  });

  // listen for changes in Supabase authentication state
  useEffect(() => {
    let isMounted = true;

    // fetch initial user
    (async () => {
      const { data } = await supabase.auth.getUser();
      if (!isMounted) return;
      setUser(data?.user || null);
    })();

    // subscribe to auth changes
    const { data: subscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user || null);
      }
    );

    return () => {
      isMounted = false;
      subscription?.subscription?.unsubscribe?.();
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);
  // useEffect(() => {
  //   const root = document.documentElement;
  //   if (theme === "dark") {
  //     root.classList.add("dark-theme");
  //   } else {
  //     root.classList.remove("dark-theme");
  //   }
  //   localStorage.setItem("theme", theme);
  // }, [theme]);

  // logout function
  const logout = async () => {
    try {
      await supabase.auth.signOut();
      setUser(null);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      theme,
      setTheme,
      logout,
      notify_popup,
      setNotify_popup,
      setShowInstallPopup,
      showInstallPopup,
    }),
    [user, setUser, theme, setTheme, logout]
  );

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

export default Context;

export const useAppContext = () => useContext(AppContext);
